import { createForm } from '@codeleap/common'

import { loginForm } from './login'

export const forgotPasswordForm = () => {
  const base = loginForm()

  return createForm('forgotPassword', {
    email: base.config.email,
    tester: base.config.tester
  })
}
